import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCommand, FiX } = FiIcons;

const SHORTCUTS = [
  { key: '⌘ / Ctrl + K', label: 'Command Palette & Quick Search' },
  { key: '` / ~', label: 'Quake Cyber Terminal CLI' },
  { key: 'Alt + G', label: 'Spatial Constellation Mindmap Graph' },
  { key: 'Alt + N', label: 'Sovereign Markdown Scratchpad' },
  { key: '⌘ / Alt + ,', label: 'System Settings Command Hub' },
  { key: 'Alt + Z', label: 'Toggle Zen Focus Mode' },
  { key: 'Alt + V', label: 'Open Zero-Knowledge Vault Manager' },
  { key: 'Alt + R', label: 'Open "Read Later" Queue Drawer' },
  { key: '?', label: 'Open Keyboard Shortcuts' },
  { key: 'Esc', label: 'Close Active Modal / Exit Focus' },
];

export default function KeyboardShortcutsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[95] flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/75 backdrop-blur-md"
        />

        <motion.div
          initial={{ opacity: 0, scale: 0.94, y: 15 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.94, y: 15 }}
          className="relative w-full max-w-sm rounded-2xl bg-[#141418] border border-[#272730] shadow-2xl p-6 z-10"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between pb-3 border-b border-[#24242c] mb-4">
            <div className="flex items-center gap-2 text-white font-bold text-sm">
              <SafeIcon icon={FiCommand} className="w-4 h-4 text-cyan-400" />
              <span>Keyboard Shortcuts</span>
            </div>
            <button
              onClick={onClose}
              className="p-1 rounded-lg text-[#666] hover:text-white hover:bg-[#222] transition-colors"
            >
              <SafeIcon icon={FiX} className="w-4 h-4" />
            </button>
          </div>

          <div className="space-y-2.5">
            {SHORTCUTS.map((s, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between p-2.5 rounded-xl bg-[#181820] border border-[#25252e] text-xs"
              >
                <span className="text-[#aaa]">{s.label}</span>
                <kbd className="font-mono text-[11px] px-2 py-0.5 rounded-md bg-[#242430] text-cyan-300 border border-[#333342] shadow-sm">
                  {s.key}
                </kbd>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
